export default __webpack_public_path__ + "assets/images/4e402582aa66c80a4c2eee063863199b.png";